<template>
  <div class="page-wrapper">
    <div class="background-page top-circle" v-if="commonDomain == true">

    </div>
    <div class="background-page" style="overflow-y: scroll" v-if="commonDomain == true">


      <div class="container" style="padding-top:220px;">
        <div class="row">
          <div class="col-12" style="margin-bottom:10px;">
            <h3 class="main-logo-title">eemo</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-6" v-for="menu in mainMenus">
            <div class="main-menu-item" v-on:click="changeCurrentModeAnim(menu.mode)">
              <div class="main-menu-item-img" v-bind:style="{backgroundImage: 'url(' + menu.url + ')'}"></div>
              <div class="main-menu-name">{{menu.name}}</div>
              <div class="main-menu-description">{{menu.description}}</div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="background-page" style="overflow-y: scroll; padding-top:47px;" v-if="commonDomain == false && merchantItem != false">
      <slider animation="fade" style="height:200px">
        <slider-item
          v-for="(img, index) in images"
          :key="index"
          style="z-index: 0; height:200px;"

        >
          <div class="restaurant-image" style="height:200px;" v-bind:style="{backgroundImage: 'url(' + img + ')'}"></div>
        </slider-item>
      </slider>


      <div class="container">
        <div class="row" style="margin-top: 30px;">
          <div class="col-6" v-for="menu in mainMenus" v-if="menu.enabled == true">
            <div class="main-menu-item" v-on:click="moveToCustomSite(menu.mode)">
              <div class="main-menu-item-img" v-bind:style="{backgroundImage: 'url(' + menu.url + ')'}"></div>
              <div class="main-menu-name">{{menu.name}}</div>
              <div class="main-menu-description">{{menu.description}}</div>
            </div>

          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="address" v-html="merchantItem.address.replace(/\n/g, '<br>')">

            </div>
            <div class="telephone">
              <a :href="'tel:' + merchantItem.contact">{{merchantItem.contact}}</a>
            </div>
          </div>
        </div>
        <div class="row" v-if="openingTime.length > 0" style="margin-top:20px;">
          <div class="col-12">
            <strong>Opening Time</strong>
          </div>
          <table class="table">
            <tr v-if="deliveryTime != false && deliveryTime.length > 0">
              <th>Day</th><th/><th>Restaurant</th><th >Delivery</th>
            </tr>
            <tr v-for="(day, di) in openingTime">
              <td>{{day.dayString}}</td>
              <td>{{day.open==true?'Open':'Close'}}</td>
              <td>
                <template v-if="day.open == true && day.times != undefined && day.times.length > 0">
                  <div v-for="time in day.times">{{time.from}} ~ {{time.to}}</div>
                </template>
              </td>
              <td v-if="deliveryTime != false && deliveryTime.length > 0">
                <template v-if="deliveryTime[di].open == true && deliveryTime[di].times != undefined && deliveryTime[di].times.length > 0">
                  <div v-for="time in deliveryTime[di].times">{{time.from}} ~ {{time.to}}</div>
                </template>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <Bottom :item="merchantItem"></Bottom>
    </div>
  </div>
</template>

<script>
  import EventBus from "../api/event-bus";

  import Bottom from "./Bottom";
  require('@/assets/css/styles.css')

  import {getMerchantUrl} from "../api/borium";
  import {isPlatformHost} from "../api/hosts";
  import Router from '../router';
  import {Slider, SliderItem} from "vue-easy-slider";
    export default {
        name: "Landing",
        data() {
          return {
            animDuration: 300,
            mainMenus: [
              {
                name: "Collect",
                url: "https://borium-rest-menus.s3.eu-west-2.amazonaws.com/ic/ic-eemo-takeout.svg",
                description: "Order and Collect.",
                mode: 'takeaway',
                enabled:true,
              },
              {
                name: "Delivery",
                url: "https://borium-rest-menus.s3.eu-west-2.amazonaws.com/ic/ic-eemo-delivery.svg",
                description: "Simply order and We will deliver",
                mode: 'delivery',
                enabled:true,
              },
              {
                name: "QRCode Order",
                url: "https://borium-rest-menus.s3.eu-west-2.amazonaws.com/ic/ic-eemo-qrcode.svg",
                description: "Simply scan QR Code on table.",
                mode: 'qrCode',
                enabled:true,
              },

              // {
              //     name:"자동주문 예약",
              //     url:"https://sj-eemo.s3.ap-northeast-2.amazonaws.com/web/ic-auto.png",
              //     description:"생활패턴에 맞춘 자동 주문해보세요.",
              //     mode:3,
              // },


            ],
            commonDomain: true,
            merchantItem:false,
            images:[],
            openingTime:[],
            deliveryTime:false,
          }
        },
        components: {
          Slider,
          SliderItem,
          Bottom,
        },
        created() {
          this.$data.commonDomain = isPlatformHost();
          if(this.$data.commonDomain === false) {
            this.getMerchantItem();
          }
        },
        mounted() {
          if(this.$data.commonDomain == true) {
            EventBus.$emit("setTitle", "");
          } else {
            EventBus.$emit("setTitle", "Hi");
          }
          EventBus.$emit("modeChanged", 0);
          $("#nav-top").removeClass("transparent-background");
        },
        methods: {
          getMerchantItem: function() {
              let url = 'https://' + window.location.host;
              if(window.location.host.startsWith('localhost')) {
                url = 'http://' + window.location.host;
              }
              let self = this;
              getMerchantUrl(url)
              .then(function(data) {
                if(data.success) {
                    self.$data.merchantItem = data.item;
                    self.setMerchant();
                  }
              })
              .catch(function(err) {
                  console.error('Request failed', err && err.response ? err.response.status : '');
              })

          },
          setMerchant: function() {
            EventBus.$emit("setTitle", this.$data.merchantItem.title);
            this.$data.images = this.$data.merchantItem.imageUrl.split(',');

            if(this.$data.merchantItem.webDelivery == 0) {
              this.$data.mainMenus[1].enabled = false;
            }
            if(this.$data.merchantItem.webTable == 0) {
              this.$data.mainMenus[2].enabled = false;
            }
            if(this.$data.merchantItem.webOrder == 0) {
              this.$data.mainMenus[0].enabled = false;
            }
            if(this.$data.merchantItem.openingTime != null && this.$data.merchantItem.openingTime.length > 3) {
              this.$data.openingTime = JSON.parse(this.$data.merchantItem.openingTime);
            }
            if(this.$data.merchantItem.deliveryTime != null && this.$data.merchantItem.deliveryTime.length > 3) {

              this.$data.deliveryTime = JSON.parse(this.$data.merchantItem.deliveryTime);
            }
          },
          changeCurrentModeAnim: function(newMode) {
            // console.log("changeCurrentModeAnim");
            setTimeout(this.changeCurrentMode, this.$data.animDuration, newMode);
          },
          moveToCustomSiteAnim: function(newMode) {
            setTimeout(this.moveToCustomSite, this.$data.animDuration, newMode);
          },
          moveToCustomSite: function(newMode) {
            if(newMode == 'qrCode') {
              EventBus.$emit("startScanner");
              return;
            }
            Router.push('/order/' + this.$data.merchantItem.merchantId + '/' + newMode);
          },
          changeCurrentMode: function(newMode) {
            if(newMode == 'qrCode') {
              EventBus.$emit("startScanner");
              return;
            }
            Router.push('/home?mode='+newMode);
          },
          codeScanned: function(code) {
            // console.log("code Scanned " + code)
            let obj = JSON.parse(code);
            if(obj != null) {
              if(obj.tableId != undefined) {
                Router.push('/restaurant?table='+obj.tableId);
              }
            }
          },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Landing.vue